import { createElement, type HTMLAttributes, type ReactNode } from 'react'

import {
  type BaseTextProps,
  getSkeletonClasses,
  getSkeletonHeight,
  getSkeletonVariant,
  getTextClasses,
  getTextTrimStyles,
} from './helpers'

type ElementType =
  | 'p'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'span'
  | 'div'
  | 'label'

interface TextProps extends BaseTextProps, HTMLAttributes<HTMLElement> {
  as?: ElementType
  children: ReactNode
  className?: string
  htmlFor?: string
}

// Text component for consistent typography
export const Text = ({
  as = 'p',
  variant = 'base',
  children,
  className = '',
  loading = false,
  balance = false,
  pretty = false,
  trim = false,
  ...props
}: TextProps) => {
  const textTrimStyles = getTextTrimStyles(trim)

  if (loading) {
    const skeletonVariant = getSkeletonVariant(variant as string, as)

    return (
      <div
        className={getSkeletonClasses(skeletonVariant, className)}
        style={{ height: getSkeletonHeight(variant as string) }}
      />
    )
  }

  return createElement(
    as,
    {
      className: getTextClasses({
        variant,
        balance,
        pretty,
        className,
      }),
      ...props,
      style: textTrimStyles,
    },
    children,
  )
}
